export default __webpack_public_path__ + "static/bandejauncuartodepollo-a0e0e757bd25c30ae9b37bfb17de0966.jpg";